'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';

//* 진행 중 참여(inProgressEntry)로 결과 화면을 복원하므로 재진입마다 캐시 없이 새로 받는다.
export const useRouletteDetail = rouletteBrandId => {
  const $ = _c(4);
  let t0;
  if ($[0] !== rouletteBrandId) {
    t0 = AuthQueryOptions["get:/wello/v1/auth/affiliate/partner-points/roulettes/{rouletteBrandId}"]({
      path: {
        rouletteBrandId
      }
    });
    $[0] = rouletteBrandId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      ...t0,
      gcTime: 0,
      select: _temp
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useSuspenseQuery(t1);
};
export type RouletteDetail = NonNullable<ReturnType<typeof useRouletteDetail>['data']>;
export type RouletteItem = RouletteDetail['itemList'][number];
function _temp(response) {
  return response.context;
}